import React, { useEffect } from 'react';
import {
    Shield, ArrowLeft, Cpu,
    CheckCircle2, MapPin, Zap, BatteryCharging, WifiOff, Lock, Sparkles, ArrowUpRight
} from 'lucide-react';
import { Link } from 'react-router-dom';

const Blebe = ({ t, isDark }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const b = t?.blebe || {};

    const storeLinks = [
        {
            name: "App Store",
            tag: "iOS",
            url: "https://apps.apple.com/mx/app/blebe/id6812009818?l=en-GB",
            icon: (
                <svg className="w-4 h-4 fill-current shrink-0" viewBox="0 0 24 24">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 6.37c.62-.75 1.04-1.8 0.93-2.85-.9.04-1.99.6-2.61 1.35-.55.63-1.03 1.68-.9 2.7.99.08 2.01-.5 2.58-1.2"/>
                </svg>
            )
        },
        {
            name: "Google Play",
            tag: "Android",
            url: "https://play.google.com/store/apps/details?id=com.tdsmx.blebe&pcampaignid=web_share",
            icon: (
                <svg className="w-4 h-4 fill-current shrink-0" viewBox="0 0 24 24">
                    <path d="M3.609 1.814L13.793 12 3.61 22.186a2.023 2.023 0 0 1-.22-.962V2.776c0-.361.082-.693.219-.962zm11.242 11.243l2.257 2.257-11.69 6.68 9.433-8.937zm0-2.114L5.418 1.998l11.69 6.688-2.257 2.257zm1.488 1.487l2.805 1.603c.895.511.895 1.352 0 1.863l-2.805 1.603-2.128-2.535 2.128-2.534z"/>
                </svg>
            )
        },
        {
            name: "AppGallery",
            tag: "Huawei",
            url: "https://appgallery.huawei.com/app/C118994443?sharePrepath=ag&locale=en_US&source=appshare&subsource=C118994443&shareTo=com.android.bluetooth&shareFrom=appmarket&shareIds=9d9af4156bca4940b0057c7f7d0339c4_com.android.bluetooth&callType=SHARE",
            icon: (
                <svg className="w-4 h-4 fill-current shrink-0" viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 4.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S13.33 8 12.5 8 11 7.33 11 6.5zm-4 4c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S9.33 12 8.5 12 7 11.33 7 10.5zm8 0c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5zm-5.5 5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5z"/>
                </svg>
            )
        }
    ];

    return (
        <div className={`min-h-screen pt-32 pb-24 px-6 transition-colors duration-700
      ${isDark ? 'bg-slate-950 text-white' : 'bg-slate-50 text-slate-900'}`}>

            <div className="container mx-auto max-w-5xl relative z-10">

                <Link to="/" className={`inline-flex items-center gap-2 mb-12 font-black uppercase text-[10px] tracking-widest transition-all hover:-translate-x-1
          ${isDark ? 'text-slate-400' : 'text-slate-600 hover:text-teal-600'}`}>
                    <ArrowLeft size={16} /> {b.back_home || "Volver al Inicio"}
                </Link>

                {/* HERO SECTION */}
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center mb-16">
                    <div className="md:col-span-7 text-left">
                        <div className="flex items-center gap-3 mb-4">
                            <span className="w-2.5 h-2.5 bg-teal-500 rounded-full animate-ping" />
                            <span className="text-[10px] font-black uppercase tracking-[0.4em] text-teal-500">{b.badge || "PLATAFORMA B2B"}</span>
                        </div>
                        <h1 className="text-5xl md:text-7xl font-black tracking-tighter italic mb-6">
                            {b.hero_title || "Blebé"}
                        </h1>
                        <p className="text-xl font-bold leading-relaxed opacity-80 mb-8">
                            {b.hero_subtitle || "Selección de personal inteligente. Reclutamiento acelerado por IA."}
                        </p>

                        {/* DESCARGAS MULTIPLATAFORMA PREMIUM */}
                        <div className="flex flex-col gap-3">
                            <span className="text-[9px] font-black uppercase tracking-[0.25em] text-teal-500/80">
                                Descarga Oficial para Candidatos
                            </span>
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-2.5">
                                {storeLinks.map((store, idx) => (
                                    <a
                                        key={idx}
                                        href={store.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`group relative p-3 rounded-2xl border transition-all duration-300 flex items-center justify-between gap-2.5 overflow-hidden ${
                                            isDark
                                                ? 'bg-slate-900/60 border-white/10 hover:border-teal-500/40 hover:bg-slate-900/90 shadow-md shadow-black/40'
                                                : 'bg-white border-slate-200 hover:border-teal-500/40 shadow-sm hover:shadow-md'
                                        }`}
                                    >
                                        <div className="flex items-center gap-2.5 min-w-0">
                                            <div className="p-2 rounded-xl bg-teal-500/10 text-teal-400 border border-teal-500/20 group-hover:scale-105 transition-transform">
                                                {store.icon}
                                            </div>
                                            <div className="text-left truncate">
                                                <span className="text-[8px] font-black uppercase tracking-wider opacity-50 block leading-tight">
                                                    {store.tag}
                                                </span>
                                                <span className="text-xs font-black tracking-tight block truncate">
                                                    {store.name}
                                                </span>
                                            </div>
                                        </div>
                                        <ArrowUpRight size={13} className="text-teal-500 opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all shrink-0" />
                                    </a>
                                ))}
                            </div>

                            <div className="pt-2">
                                <Link
                                    to="/proyectos/Blebe/privacidad"
                                    className="inline-flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-teal-500/90 hover:text-teal-400 transition-colors py-1 group"
                                >
                                    <Shield size={13} />
                                    <span>{b.privacy_btn || "Aviso de Privacidad Integral"}</span>
                                    <ArrowUpRight size={11} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform opacity-70" />
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="md:col-span-5 flex justify-center">
                        <div className={`w-64 h-64 rounded-[3rem] border backdrop-blur-3xl flex items-center justify-center relative shadow-2xl
              ${isDark ? 'bg-slate-900/60 border-white/10 shadow-black/50' : 'bg-white border-slate-200 shadow-teal-500/10'}`}>

                            <div className="w-36 h-36 rounded-full overflow-hidden flex items-center justify-center bg-teal-500/5 border border-teal-500/20 p-3">
                                <img
                                    src="/logo_blebe.png"
                                    alt="Blebé Logo"
                                    className="w-full h-full object-contain"
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                        e.target.parentNode.innerHTML = '<span class="text-4xl font-black text-teal-500 italic">Blebé</span>';
                                    }}
                                />
                            </div>

                            <div className="absolute -inset-4 rounded-[3.5rem] border border-teal-500/20 animate-spin" style={{ animationDuration: '18s' }} />
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 text-left">
                    {/* ORIGEN LINGÜÍSTICO */}
                    <div className={`p-8 md:p-10 rounded-[3.5rem] border backdrop-blur-3xl
        ${isDark ? 'bg-slate-900/40 border-white/10' : 'bg-white border-slate-200 shadow-lg shadow-teal-500/5'}`}>
                        <span className="text-[9px] font-black uppercase tracking-widest text-teal-500 block mb-2">
                            ORIGEN LINGÜÍSTICO
                        </span>
                        <h2 className="text-2xl font-black uppercase tracking-tight mb-4">
                            El Significado de Blebé
                        </h2>
                        <p className="text-sm font-bold opacity-60 leading-relaxed">
                            Proviene de la variante del <strong className="text-teal-500">Zapoteco de la Sierra Juárez</strong>, donde <strong className="text-teal-500">Blebé</strong> significa <strong className="text-teal-500">"Escogido" o "Elegido"</strong>.
                        </p>
                        <p className="text-sm font-bold opacity-60 leading-relaxed mt-4">
                            Refleja el núcleo de nuestra plataforma: brindarte la tecnología y el análisis profundo para que <strong>identifiques y selecciones con certeza</strong> al talento ideal para tu empresa.
                        </p>
                    </div>

                    {/* PILARES DE MARCA */}
                    <div className={`p-8 md:p-10 rounded-[3.5rem] border backdrop-blur-3xl
        ${isDark ? 'bg-slate-900/40 border-white/10' : 'bg-white border-slate-200 shadow-lg shadow-teal-500/5'}`}>
                        <span className="text-[9px] font-black uppercase tracking-widest text-blue-500 block mb-2">
                            {b.brand_pillars?.logo?.tag || "IDENTIDAD & CRITERIO"}
                        </span>
                        <h2 className="text-2xl font-black uppercase tracking-tight mb-4">
                            {b.brand_pillars?.logo?.title || "La Dualidad en la Selección"}
                        </h2>
                        <p className="text-sm font-bold opacity-60 leading-relaxed">
                            {b.brand_pillars?.logo?.desc_p1 || "El imagotipo de Blebé sintetiza la unión entre "}
                            <strong>{b.brand_pillars?.logo?.highlight1 || "la agilidad algorítmica"}</strong>
                            {b.brand_pillars?.logo?.desc_p2 || " y "}
                            <strong>{b.brand_pillars?.logo?.highlight2 || "la empatía y juicio humano"}</strong>
                            {b.brand_pillars?.logo?.desc_p3 || ", asegurando evaluaciones justas y sin sesgos automatizados."}
                        </p>
                    </div>
                </div>

                {/* EFICIENCIA OPERATIVA */}
                <div className={`p-8 md:p-12 rounded-[3.5rem] border backdrop-blur-3xl mb-12 text-left
                    ${isDark ? 'bg-slate-900/40 border-white/10' : 'bg-white border-slate-200 shadow-lg shadow-teal-500/5'}`}>
                    <div className="flex items-center gap-3 mb-4">
                        <div className="p-2 bg-teal-500/10 rounded-lg text-teal-500">
                            <MapPin size={22} />
                        </div>
                        <div>
                            <span className="text-[9px] font-black uppercase tracking-widest text-teal-500 block">EFICIENCIA OPERATIVA</span>
                            <h2 className="text-2xl font-black uppercase tracking-tight">Experiencia del Candidato</h2>
                        </div>
                    </div>

                    <p className="text-sm font-bold opacity-70 leading-relaxed mb-8">
                        Nuestra plataforma está diseñada para que el candidato complete sus evaluaciones de forma ágil desde cualquier dispositivo, <strong>garantizando altas tasas de finalización</strong> y reduciendo el abandono a la mitad del proceso.
                    </p>

                    <h4 className="text-xs font-black uppercase tracking-widest text-teal-500 mb-4">VENTAJAS DE LA APLICACIÓN</h4>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div className={`p-6 rounded-[2rem] border h-full flex flex-col justify-between transition-all duration-300 ${isDark
                            ? 'bg-slate-900/40 border-white/5 hover:border-teal-500/20'
                            : 'bg-white border-slate-200/80 hover:border-teal-500/30 shadow-sm'
                            }`}>
                            <div>
                                <div className="flex items-center gap-2 text-teal-500 mb-3 font-black text-sm">
                                    <BatteryCharging size={18} /> Optimización de Batería
                                </div>
                                <p className="text-xs font-bold opacity-75 leading-relaxed">
                                    El proceso de evaluación y subida de documentos opera de forma inteligente en segundo plano. Esto asegura que la batería y los datos móviles del candidato no se agoten bruscamente.
                                </p>
                            </div>
                        </div>

                        <div className={`p-6 rounded-[2rem] border ${isDark ? 'bg-slate-950/40 border-white/5' : 'bg-slate-50 border-slate-200'}`}>
                            <div className="flex items-center gap-2 text-blue-500 mb-2 font-black text-sm">
                                <WifiOff size={18} /> Resiliencia sin Conexión
                            </div>
                            <p className="text-xs font-bold opacity-60 leading-relaxed">
                                Si el candidato pierde la señal durante una prueba, el sistema guarda su progreso localmente y lo sincroniza de forma automática en cuanto recupera la red, evitando que pierda su avance.
                            </p>
                        </div>

                        <div className={`p-6 rounded-[2rem] border ${isDark ? 'bg-slate-950/40 border-white/5' : 'bg-slate-50 border-slate-200'}`}>
                            <div className="flex items-center gap-2 text-purple-500 mb-2 font-black text-sm">
                                <Zap size={18} /> Alto Rendimiento
                            </div>
                            <p className="text-xs font-bold opacity-60 leading-relaxed">
                                La plataforma respeta los estados de reposo del teléfono. Garantizamos que el uso de la aplicación no sobrecaliente ni ponga lento el dispositivo del usuario.
                            </p>
                        </div>
                    </div>
                </div>

                {/* COMPARATIVA DE AHORRO B2B */}
                <div className={`p-8 md:p-12 rounded-[3.5rem] border backdrop-blur-3xl mb-12 text-left
                    ${isDark ? 'bg-slate-900/40 border-white/10' : 'bg-white border-slate-200 shadow-lg shadow-teal-500/5'}`}>
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 mb-8">
                        <div>
                            <span className="text-[9px] font-black uppercase tracking-widest text-teal-500 block mb-2">VENTAJA COMPETITIVA</span>
                            <h2 className="text-2xl md:text-3xl font-black uppercase tracking-tight">Optimización de Presupuesto</h2>
                        </div>
                    </div>

                    <div className="overflow-x-auto no-scrollbar">
                        <table className="w-full text-left border-collapse min-w-[600px]">
                            <thead>
                                <tr className={`border-b ${isDark ? 'border-white/10' : 'border-slate-200'}`}>
                                    <th className="pb-4 font-black uppercase text-[10px] tracking-wider opacity-50 w-1/3">Concepto de Evaluación</th>
                                    <th className="pb-4 font-black uppercase text-[10px] tracking-wider opacity-50 w-1/3">Mercado Tradicional</th>
                                    <th className="pb-4 font-black uppercase text-[10px] tracking-wider text-teal-500 w-1/3">Plataforma Blébe</th>
                                </tr>
                            </thead>
                            <tbody className="text-sm font-bold opacity-80">
                                <tr className={`border-b ${isDark ? 'border-white/5' : 'border-slate-100'}`}>
                                    <td className="py-4">Filtro de CV</td>
                                    <td className="py-4 opacity-50">~$200 MXN + IVA</td>
                                    <td className="py-4 text-teal-500 flex items-center gap-2"><CheckCircle2 size={16} /> Incluido (Análisis IA)</td>
                                </tr>
                                <tr className={`border-b ${isDark ? 'border-white/5' : 'border-slate-100'}`}>
                                    <td className="py-4">Prueba Psicométrica</td>
                                    <td className="py-4 opacity-50">$300 - $500 MXN + IVA</td>
                                    <td className="py-4 text-teal-500 flex items-center gap-2"><CheckCircle2 size={16} /> Incluido</td>
                                </tr>
                                <tr className={`border-b ${isDark ? 'border-white/5' : 'border-slate-100'}`}>
                                    <td className="py-4">Estudio Socioeconómico</td>
                                    <td className="py-4 opacity-50">$800 - $1,200 MXN + IVA</td>
                                    <td className="py-4 text-teal-500 flex items-center gap-2"><CheckCircle2 size={16} /> Incluido (100% Digital)</td>
                                </tr>
                                <tr className={`border-b ${isDark ? 'border-white/5' : 'border-slate-100'}`}>
                                    <td className="py-4">Gestión Documental</td>
                                    <td className="py-4 opacity-50">~$150 MXN + IVA</td>
                                    <td className="py-4 text-teal-500 flex items-center gap-2"><CheckCircle2 size={16} /> Incluido (Bóveda Digital)</td>
                                </tr>
                                <tr className="text-base md:text-lg font-black">
                                    <td className="py-6">Costo Total por Candidato</td>
                                    <td className="py-6 text-red-500/80 line-through decoration-2">$1,450 - $2,050 MXN + IVA</td>
                                    <td className="py-6 text-teal-500 text-2xl">$650 MXN <span className="text-xs font-bold opacity-80">+ IVA</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="mt-6 p-4 rounded-2xl bg-teal-500/10 border border-teal-500/20 text-teal-500 text-xs md:text-sm font-bold flex items-center gap-3">
                        <Zap size={20} className="shrink-0" />
                        <span>Ahorro corporativo de hasta un 68% por vacante, reduciendo los tiempos de contratación de semanas a días.</span>
                    </div>
                </div>

                {/* PAQUETES Y MÓDULOS DE PRECIOS */}
                <h3 className="text-xs font-black uppercase tracking-[0.4em] text-teal-500 text-left mb-6 pl-4">Planes de Evaluación</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left mb-12">

                    {/* Módulo A */}
                    <div className={`p-8 rounded-[2.5rem] border flex flex-col transition-all duration-300 ${isDark ? 'bg-slate-900/20 border-white/5 hover:border-teal-500/30' : 'bg-white border-slate-100 shadow-sm hover:border-teal-500/30'}`}>
                        <h4 className="text-xl font-black mb-1">Módulo A</h4>
                        <p className="text-[11px] font-bold opacity-50 uppercase tracking-wider mb-6">Filtro Psicométrico</p>
                        <div className="text-4xl font-black mb-1">$350 <span className="text-sm opacity-50 font-bold">MXN</span></div>
                        <span className="text-[10px] font-black uppercase tracking-wider text-teal-500 mb-2">+ IVA</span>
                        <p className="text-[10px] font-bold opacity-50 mb-8">Por candidato evaluado</p>

                        <ul className="space-y-3 text-xs font-bold opacity-70 flex-grow mb-8">
                            <li className="flex items-center gap-3"><CheckCircle2 size={16} className="text-teal-500 shrink-0" /> Batería Psicométrica</li>
                            <li className="flex items-center gap-3"><CheckCircle2 size={16} className="text-teal-500 shrink-0" /> Análisis de CV con IA</li>
                            <li className="flex items-center gap-3"><CheckCircle2 size={16} className="text-teal-500 shrink-0" /> Recaudación de Documentos</li>
                        </ul>
                    </div>

                    {/* Módulo B */}
                    <div className={`p-8 rounded-[2.5rem] border flex flex-col transition-all duration-300 ${isDark ? 'bg-slate-900/20 border-white/5 hover:border-teal-500/30' : 'bg-white border-slate-100 shadow-sm hover:border-teal-500/30'}`}>
                        <h4 className="text-xl font-black mb-1">Módulo B</h4>
                        <p className="text-[11px] font-bold opacity-50 uppercase tracking-wider mb-6">Filtro Socioeconómico</p>
                        <div className="text-4xl font-black mb-1">$450 <span className="text-sm opacity-50 font-bold">MXN</span></div>
                        <span className="text-[10px] font-black uppercase tracking-wider text-teal-500 mb-2">+ IVA</span>
                        <p className="text-[10px] font-bold opacity-50 mb-8">Por candidato evaluado</p>

                        <ul className="space-y-3 text-xs font-bold opacity-70 flex-grow mb-8">
                            <li className="flex items-center gap-3"><CheckCircle2 size={16} className="text-teal-500 shrink-0" /> Estudio Socioeconómico Digital</li>
                            <li className="flex items-center gap-3"><CheckCircle2 size={16} className="text-teal-500 shrink-0" /> Análisis de CV con IA</li>
                            <li className="flex items-center gap-3"><CheckCircle2 size={16} className="text-teal-500 shrink-0" /> Recaudación de Documentos</li>
                        </ul>
                    </div>

                    {/* Módulo Completo */}
                    <div className={`p-8 rounded-[2.5rem] border flex flex-col relative overflow-hidden transition-all duration-300 ${isDark ? 'bg-teal-900/10 border-teal-500/30 shadow-[0_0_30px_-10px_rgba(20,184,166,0.2)]' : 'bg-teal-50 border-teal-200 shadow-lg shadow-teal-500/10'}`}>
                        <div className="absolute top-0 right-0 bg-teal-500 text-white text-[9px] font-black uppercase tracking-widest py-1.5 px-4 rounded-bl-2xl">Recomendado</div>

                        <h4 className="text-xl font-black mb-1 text-teal-500">Módulo Completo</h4>
                        <p className="text-[11px] font-bold text-teal-500/70 uppercase tracking-wider mb-6">Ciclo 360° Integral</p>
                        <div className="text-4xl font-black mb-1 text-teal-500">$650 <span className="text-sm opacity-70 font-bold">MXN</span></div>
                        <span className="text-[10px] font-black uppercase tracking-wider text-teal-500 mb-2">+ IVA</span>
                        <p className="text-[10px] font-bold text-teal-500/70 mb-8">Por candidato evaluado (1 a 10 pruebas)</p>

                        <ul className="space-y-3 text-xs font-bold opacity-80 flex-grow mb-8">
                            <li className="flex items-center gap-3"><CheckCircle2 size={16} className="text-teal-500 shrink-0" /> Batería Psicométrica</li>
                            <li className="flex items-center gap-3"><CheckCircle2 size={16} className="text-teal-500 shrink-0" /> Estudio Socioeconómico Digital</li>
                            <li className="flex items-center gap-3"><CheckCircle2 size={16} className="text-teal-500 shrink-0" /> Análisis de CV con IA</li>
                            <li className="flex items-center gap-3"><CheckCircle2 size={16} className="text-teal-500 shrink-0" /> Recaudación de Documentos</li>
                        </ul>

                        <div className={`pt-4 border-t ${isDark ? 'border-teal-500/20' : 'border-teal-500/20'}`}>
                            <p className="text-[10px] font-bold opacity-75 leading-relaxed">
                                * Descuentos por volumen (+ IVA):<br />
                                1 a 10 pruebas: <strong className="text-teal-500">$650 MXN</strong><br />
                                De 11 a 50 pruebas: <strong className="text-teal-500">$600 MXN</strong><br />
                                Más de 50 pruebas: <strong className="text-teal-500">$550 MXN</strong>
                            </p>
                        </div>
                    </div>
                </div>

                {/* INFRAESTRUCTURA TÉCNICA */}
                <h4 className="text-xs font-black uppercase tracking-[0.4em] text-teal-500 text-left mb-6 pl-4">INFRAESTRUCTURA DE ALTO NIVEL</h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left mb-12">
                    {[
                        { icon: <Cpu size={24} />, title: "Procesamiento Inteligente", desc: "Extracción automatizada de datos y análisis estructurado para acelerar la lectura de CVs." },
                        { icon: <Lock size={24} />, title: "Bóveda Cifrada", desc: "Almacenamiento de alta seguridad para proteger documentos e información sensible." },
                        { icon: <Sparkles size={24} />, title: "Experiencia sin Fricción", desc: "Interfaces diseñadas bajo estándares modernos para minimizar el estrés cognitivo del usuario." }
                    ].map((item, idx) => (
                        <div key={idx} className={`p-8 rounded-[2.5rem] border transition-all duration-300
              ${isDark ? 'bg-slate-900/30 border-white/5 hover:border-teal-500/20' : 'bg-white border-slate-200 hover:border-teal-500/20 shadow-md shadow-teal-500/5'}`}>
                            <div className="text-teal-500 mb-4">{item.icon}</div>
                            <h3 className="text-lg font-black mb-2">{item.title}</h3>
                            <p className="text-xs font-bold opacity-50 leading-relaxed">{item.desc}</p>
                        </div>
                    ))}
                </div>

                {/* PRUEBA GRATUITA */}
                <div className={`p-8 md:p-12 rounded-[3.5rem] border backdrop-blur-3xl mb-12 text-left relative overflow-hidden
    ${isDark ? 'bg-teal-900/10 border-teal-500/30' : 'bg-teal-50 border-teal-200 shadow-xl shadow-teal-500/10'}`}>
                    <div className="absolute top-0 right-0 bg-teal-500 text-white text-[9px] font-black uppercase tracking-widest py-2 px-6 rounded-bl-3xl z-20">
                        Sin Compromiso
                    </div>

                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-8 relative z-10">
                        <div className="md:w-1/2">
                            <span className="text-[9px] font-black uppercase tracking-widest text-teal-500 block mb-2">PRUEBA GRATUITA</span>
                            <h2 className="text-3xl md:text-4xl font-black uppercase tracking-tight mb-4">Comienza a evaluar hoy</h2>
                            <p className="text-sm font-bold opacity-70 leading-relaxed mb-6">
                                Solicita tu entorno de prueba y obtén <strong>5 licencias del Módulo Completo (Psicometría + Socioeconómico + IA)</strong> totalmente gratis. Conoce el ahorro y la eficiencia de primera mano.
                            </p>
                        </div>

                        <div className="md:w-1/2 flex flex-col gap-4">
                            <p className="text-[10px] font-black uppercase tracking-widest opacity-50 mb-1 pl-2">Contacta a un Asesor Autorizado:</p>

                            {/* Asesor 1 - Arturo */}
                            <a
                                href="https://wa.me/5215535784645?text=Hola,%20me%20interesa%20la%20prueba%20gratuita%20de%205%20licencias%20de%20Bleb%C3%A9"
                                target="_blank"
                                rel="noreferrer"
                                className={`flex items-center gap-4 p-4 rounded-2xl border transition-all duration-300 hover:border-teal-500 hover:shadow-lg cursor-pointer ${isDark ? 'bg-slate-900/60 border-white/10' : 'bg-white border-slate-200'}`}
                            >
                                <div className="w-10 h-10 rounded-full bg-teal-500/10 flex items-center justify-center text-teal-500 shrink-0">
                                    <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>
                                </div>
                                <div>
                                    <p className="text-sm font-black">Arturo Hernández</p>
                                    <p className="text-[10px] font-bold opacity-60">WhatsApp: 55 3578 4645</p>
                                </div>
                            </a>

                            {/* Asesor 2 - Carlos */}
                            <a
                                href="https://wa.me/5215660510226?text=Hola,%20me%20interesa%20la%20prueba%20gratuita%20de%205%20licencias%20de%20Bleb%C3%A9"
                                target="_blank"
                                rel="noreferrer"
                                className={`flex items-center gap-4 p-4 rounded-2xl border transition-all duration-300 hover:border-teal-500 hover:shadow-lg cursor-pointer ${isDark ? 'bg-slate-900/60 border-white/10' : 'bg-white border-slate-200'}`}
                            >
                                <div className="w-10 h-10 rounded-full bg-teal-500/10 flex items-center justify-center text-teal-500 shrink-0">
                                    <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>
                                </div>
                                <div>
                                    <p className="text-sm font-black">Carlos Pelcastre</p>
                                    <p className="text-[10px] font-bold opacity-60">WhatsApp: 56 6051 0226</p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Blebe;